import React from 'react';
import TextArea from '@wix/da-ds/pkg/formControls/dsPresets/TextArea';
const Textarea = /*#__PURE__*/ React.forwardRef(({ label , maxLength , error , name , placeholder , errorMessage , id , value , defaultValue , textareaClassName , rows , autoSize , onFocus , onBlur , onChange , noBottomSpacing  }, ref)=>{
    const onKeyDown = (e)=>{
        if ([
            'ArrowUp',
            'ArrowDown',
            'ArrowLeft',
            'ArrowRight'
        ].includes(e.key)) {
            return;
        }
        const el = e.target;
        el.style.height = 'inherit';
        const computed = window.getComputedStyle(el);
        let desiredHeight = el.scrollHeight;
        for (const k of [
            'border-top-width',
            'padding-top',
            'padding-bottom',
            'border-bottom-width'
        ]){
            desiredHeight += parseInt(computed.getPropertyValue(k), 10);
        }
        el.style.height = `${desiredHeight}px`;
    };
    return /*#__PURE__*/ React.createElement(TextArea, {
        value: value || undefined,
        defaultValue: defaultValue || undefined,
        id: id !== null && id !== void 0 ? id : '',
        label: label !== null && label !== void 0 ? label : '',
        isLabelHidden: label === '' || label === undefined,
        ref: ref,
        name: name,
        rows: rows,
        validationResult: error || !!errorMessage ? 'error' : undefined,
        details: errorMessage || undefined,
        maxLength: maxLength,
        placeholder: placeholder,
        className: textareaClassName,
        onFocus: (e)=>{
            onFocus && onFocus(e);
        },
        onBlur: (e)=>{
            onBlur && onBlur(e);
        },
        onChange: (e)=>{
            const v = e.target.value;
            onChange && onChange(v, e);
        },
        onKeyDown: autoSize ? onKeyDown : undefined,
        noBottomSpacing: noBottomSpacing
    });
});
Textarea.displayName = 'Textarea';
export default Textarea;
